export default __webpack_public_path__ + "static/media/dia1.ba033a92.png";